export default __webpack_public_path__ + "static/media/Trash_duotone_line.40b95242.svg";